/**
 * Sprint 2.8c §F.5 — i18n passthrough.
 *
 * The Progress tab is English-only at launch. Every customer-facing string
 * passes through `t()` so that when localisation is wired, only the
 * implementation of this function needs to change — not the call sites.
 *
 * `t(key, fallback, params?)` returns `fallback` with `{param}` substitution
 * until an i18n backend is configured.
 */

export type Locale = 'en-GB';

/**
 * Translate a key, returning the English fallback with optional param
 * substitution. Params replace `{name}` placeholders in the fallback string.
 */
export function t(
  _key: string,
  fallback: string,
  params?: Record<string, string | number>,
): string {
  if (!params) return fallback;
  return fallback.replace(/\{(\w+)\}/g, (_, k) =>
    String(params[k as string] ?? `{${k}}`),
  );
}
